export const removeCanonicalLink = () => {
  const existing = document.querySelector('link[rel="canonical"]')

  if (existing) existing.remove()
}

export const setCanonicalLink = (href) => {
  if (!href) {
    removeCanonicalLink()
    return
  }

  let link = document.querySelector('link[rel="canonical"]')

  if (!link) {
    link = document.createElement('link')
    link.setAttribute('rel', 'canonical')
    document.head.appendChild(link)
  }

  link.setAttribute('href', href)
}

export const buildDefaultCanonicalHref = (to) => {
  const { origin } = window.location
  const path = to && typeof to.path === 'string' ? to.path : ''

  return `${origin}${path}`
}

export const removeRobotsMeta = () => {
  const existing = document.querySelector('meta[name="robots"]')

  if (existing) existing.remove()
}

export const setNoindexRobotsMeta = () => {
  let meta = document.querySelector('meta[name="robots"]')

  if (!meta) {
    meta = document.createElement('meta')
    meta.name = 'robots'
    document.head.appendChild(meta)
  }
  meta.content = 'noindex, nofollow'
}

export const removeMetaTag = (name) => {
  const existing = document.querySelector(`meta[name="${name}"]`)

  if (existing) existing.remove()
}

export const setMetaTag = (name, content) => {
  if (!name) return

  let meta = document.querySelector(`meta[name="${name}"]`)

  if (!meta) {
    meta = document.createElement('meta')
    meta.name = name
    document.head.appendChild(meta)
  }

  if (typeof content === 'string') {
    meta.content = content
  } else {
    meta.removeAttribute('content')
  }
}

export const applyRobotsForRoute = (to) => {
  const shouldNoindex = !!(to.meta && to.meta.noindex)

  if (shouldNoindex) {
    setNoindexRobotsMeta()
  } else {
    removeRobotsMeta()
  }
}

export const isCanonicalDenied = (to) => {
  const denyNames = new Set([
    // Add denylist routes here
  ])
  return denyNames.has(to.name)
}

export const applyCanonicalForRoute = (to) => {
  if (isCanonicalDenied(to)) {
    removeCanonicalLink()

    return
  }

  const href = buildDefaultCanonicalHref(to)
  setCanonicalLink(href)
}

export const applySeoForRoute = (to) => {
  applyRobotsForRoute(to)
  applyCanonicalForRoute(to)
}
